// extracted by mini-css-extract-plugin
export default {"sliderIndicator":"gameImageSlider_sliderIndicator__az8Jw","active":"gameImageSlider_active__XSM1h"};